function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { throw: 1, return: 2, break: 3, continue: 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, catch: function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Button, Icon } from '@unite-us/app-components';
import { compact, get } from 'lodash';
import React, { useState, useEffect } from 'react';
import { NEXT_STEPS } from '../builder/constants';
import { CALLBACKS, APP_ENVIRONMENT, INITIAL_ADDRESSES, COMPONENTS } from '../../api/config';
import { coreApi } from '../../api/config';
import { useAppCreateReferralContext } from '../../context/AppCreateReferralProvider';
import useUpdateResourceList from '../../hooks/useUpdateResourceList';
import useCreateResourceList from '../../hooks/useCreateResourceList';
import useCreateShareEvent from '../../hooks/useCreateShareEvent';
import { isUnlistedProgram, filterProgramsUnlisted } from '../builder/utils';
import CreateReferralContainer from '../../components/CreateReferralContainer';
import { useFeatureFlag } from '../../utils/useFeatureFlag';
import getProgramServicesPayload from '../../utils/getProgramServicesPayload';
import { urls } from '@unite-us/client-utils';
var REFERRAL_STATUS = {
  FAILED: 'failed',
  PARTIAL: 'partial',
  SUCCESS: 'success'
};
var MESSAGES = {
  FORWARD: _defineProperty(_defineProperty(_defineProperty({}, REFERRAL_STATUS.SUCCESS, 'Referrals Successfully Forwarded!'), REFERRAL_STATUS.PARTIAL, 'Some Referrals Successfully Forwarded'), "DEFAULT", 'Referrals Not Forwarded!'),
  CREATE: _defineProperty(_defineProperty(_defineProperty({}, REFERRAL_STATUS.SUCCESS, 'Referrals Successfully Created!'), REFERRAL_STATUS.PARTIAL, 'Some Referrals Successfully Created'), "DEFAULT", 'Referrals Not Created')
};
export default function ReferralsSent(_ref) {
  var referrals = _ref.referrals,
    isSuccessfullyForwarded = _ref.isSuccessfullyForwarded,
    referralsResultDetail = _ref.referralsResultDetail,
    isForwardReferralPath = _ref.isForwardReferralPath;
  var _useAppCreateReferral = useAppCreateReferralContext(),
    _useAppCreateReferral2 = _useAppCreateReferral.state,
    currentEmployee = _useAppCreateReferral2.currentEmployee,
    source = _useAppCreateReferral2.source,
    resourceListId = _useAppCreateReferral2.resourceListId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shareDrawerOpen = _useState2[0],
    setShareDrawerOpen = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedProgramsWithName = _useState4[0],
    setSelectedProgramsWithName = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    successfullySentStatus = _useState6[0],
    setSuccessfullySentStatus = _useState6[1];
  var updateResourceList = useUpdateResourceList(resourceListId);
  var createResourceList = useCreateResourceList();
  var createShareEvent = useCreateShareEvent();
  var ShareDrawer = COMPONENTS.ShareDrawer;
  var isEmrSource = source === 'emr';
  var clientProfileBtnText = isEmrSource ? 'Go to client’s profile' : 'Go To Face Sheet';
  var hint1980ShowSharesMessageBox = useFeatureFlag('hint1980ShowSharesMessageBox', false);
  var isUnlistedReferral = filterProgramsUnlisted(referrals).length === 0;
  var nextSteps = isUnlistedReferral ? NEXT_STEPS.slice(2) : NEXT_STEPS;
  useEffect(function () {
    var newReferrals = compact(referrals);
    var referralsWithPrograms = _toConsumableArray(new Set(newReferrals.flatMap(function (r) {
      return r.programs;
    })));
    var referralServices = _toConsumableArray(new Set(newReferrals.flatMap(function (r) {
      return r.service;
    })));
    var programsWithName = referralsWithPrograms.filter(function (program) {
      return !isUnlistedProgram(program);
    }).map(function (program) {
      var _program$provider, _program$services;
      return {
        id: program.id,
        name: program.name,
        isSensitive: ((_program$provider = program.provider) === null || _program$provider === void 0 ? void 0 : _program$provider.sensitive) || ((_program$services = program.services) === null || _program$services === void 0 ? void 0 : _program$services.some(function (s) {
          var _referralServices$fin;
          return referralServices === null || referralServices === void 0 || (_referralServices$fin = referralServices.find(function (rs) {
            return rs.id === s.id;
          })) === null || _referralServices$fin === void 0 ? void 0 : _referralServices$fin.sensitive;
        }))
      };
    });
    setSelectedProgramsWithName(programsWithName);
  }, [referrals]);
  function saveShareEvent(_x, _x2) {
    return _saveShareEvent.apply(this, arguments);
  }
  function _saveShareEvent() {
    _saveShareEvent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(shareMethod, language) {
      var programServicesPayload, currentResourceListId, _yield$createResource, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            programServicesPayload = getProgramServicesPayload(filterProgramsUnlisted(referrals));
            currentResourceListId = resourceListId;
            if (currentResourceListId) {
              _context.next = 20;
              break;
            }
            _context.prev = 3;
            _context.next = 6;
            return createResourceList({
              language: language,
              source: source,
              programServicesPayload: programServicesPayload
            });
          case 6:
            _yield$createResource = _context.sent;
            response = _yield$createResource.response;
            if (!(!response || !response.data || !response.data.data)) {
              _context.next = 10;
              break;
            }
            throw new Error('Invalid response structure from createResourceList');
          case 10:
            if (response.data.data.sent_to_ehr) {
              CALLBACKS.notify.success("The resource list is being sent to the EHR system");
            }
            currentResourceListId = response.data.data.id;
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](3);
            CALLBACKS.notify.error("Failed to create resource list");
            throw _context.t0;
          case 18:
            _context.next = 21;
            break;
          case 20:
            updateResourceList({
              programServicesPayload: programServicesPayload
            });
          case 21:
            createShareEvent(referrals, currentResourceListId, shareMethod);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 14]]);
    }));
    return _saveShareEvent.apply(this, arguments);
  }
  var windowMessage = function windowMessage() {
    if (!referrals.status && !successfullySentStatus) {
      return "Referrals Successfully ".concat(isSuccessfullyForwarded ? 'Forwarded' : 'Created', "!");
    }
    var messageType = isForwardReferralPath ? 'FORWARD' : 'CREATE';
    return MESSAGES[messageType][successfullySentStatus] || MESSAGES[messageType].DEFAULT;
  };
  useEffect(function () {
    if (!referralsResultDetail || referralsResultDetail.length === 0) {
      setSuccessfullySentStatus(null);
      return;
    }
    var totalReferrals = referralsResultDetail.length;
    var successfulReferrals = referralsResultDetail.filter(function (referral) {
      return referral.sent;
    }).length;
    if (successfulReferrals === 0) {
      setSuccessfullySentStatus(REFERRAL_STATUS.FAILED);
    } else if (successfulReferrals < totalReferrals) {
      setSuccessfullySentStatus(REFERRAL_STATUS.PARTIAL);
    } else {
      setSuccessfullySentStatus(REFERRAL_STATUS.SUCCESS);
    }
  }, [referralsResultDetail]);
  var referralStatus = function referralStatus() {
    return referralsResultDetail && referralsResultDetail.map(function (_ref2) {
      var sent = _ref2.sent,
        index = _ref2.index;
      var referralName = "Referral ".concat(index + 1, ": ").concat(get(referrals[index], 'service.name'));
      return /*#__PURE__*/React.createElement("div", {
        className: "flex flex-col p-4 pb-4 mx-auto border border-solid border-table-border-color"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "uppercase font-black text-grey text-base mr-4"
      }, referralName), /*#__PURE__*/React.createElement("div", {
        className: "flex flex-row items-center"
      }, !sent ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        className: "text-white fill-current bg-red rounded-full p-1 mr-4",
        icon: 'Cross',
        size: 10
      }), /*#__PURE__*/React.createElement("h2", {
        className: "text-base font-black text-red"
      }, "Error: Referral creation failed. Get help resolving the issue by reaching out to", /*#__PURE__*/React.createElement("button", {
        id: "website-link",
        className: "text-base ui-contact-information__icon-text--website pl-quarter underline text-blue-600",
        onClick: function onClick() {
          window.open(urls.addHttpIfNeeded('support@uniteus.com'), '_blank', 'noopener,noreferrer');
        },
        title: 'Organization Website'
      }, 'support@uniteus.com.'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
        className: "mr-4",
        color: 'green',
        icon: 'CheckCircle',
        size: 18
      }), /*#__PURE__*/React.createElement("h2", {
        className: "text-base font-black text-dark-green"
      }, "Referral successfully created."))));
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CreateReferralContainer, {
    isStepReferralSent: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-around"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-10 bg-white ".concat(successfullySentStatus === REFERRAL_STATUS.SUCCESS ? "w-3/6" : "w-4/6", " my-10")
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-4xl ".concat(isEmrSource ? 'mb-10' : 'mb-15', " text-center font-proxima-nova font-semibold")
  }, windowMessage()), /*#__PURE__*/React.createElement("div", {
    className: "space-y-2"
  }, referralStatus()), successfullySentStatus !== REFERRAL_STATUS.FAILED && /*#__PURE__*/React.createElement("div", {
    className: "".concat(successfullySentStatus === REFERRAL_STATUS.SUCCESS ? "w-8/12" : "w-6/12", " p-4 mt-6 text-center mx-auto bg-white-grey border border-solid\n                border-table-border-color rounded")
  }, /*#__PURE__*/React.createElement("h1", {
    className: "font-black text-center text-lg pb-2 ".concat(isEmrSource && 'pt-5')
  }, "Next Steps"), /*#__PURE__*/React.createElement("div", {
    className: "text-left p-2 ".concat(isEmrSource && 'pb-5')
  }, nextSteps.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: "list-none mb-1",
      key: item
    }, item);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center gap-4 ".concat(isEmrSource ? 'pt-10' : 'mt-6')
  }, /*#__PURE__*/React.createElement(Button, {
    id: "clientProfile",
    onClick: function onClick() {
      CALLBACKS.onReferralCompleted();
    },
    className: "font-semibold normal-case w-64 rounded ".concat(isEmrSource && 'border-black'),
    label: clientProfileBtnText,
    omitDefaultStyles: isEmrSource,
    outline: true
  }), !isUnlistedReferral && /*#__PURE__*/React.createElement(Button, {
    id: "share",
    iconLeft: /*#__PURE__*/React.createElement(Icon, {
      icon: "IconMailForward",
      color: "white"
    }),
    onClick: function onClick() {
      setShareDrawerOpen(true);
    },
    primary: true,
    className: "font-semibold bg-current-blue normal-case w-64",
    label: "Share Resources",
    disabled: successfullySentStatus === REFERRAL_STATUS.FAILED
  })), /*#__PURE__*/React.createElement(ShareDrawer, {
    employeeId: currentEmployee === null || currentEmployee === void 0 ? void 0 : currentEmployee.id,
    coreApi: coreApi,
    SHARES_URL: APP_ENVIRONMENT.sharesUrl,
    show: shareDrawerOpen,
    onClose: function onClose() {
      return setShareDrawerOpen(false);
    },
    onShare: function onShare(_ref3) {
      var shareMethod = _ref3.shareMethod,
        language = _ref3.language;
      return saveShareEvent(shareMethod, language);
    },
    resourceType: "program",
    resources: selectedProgramsWithName,
    providerId: APP_ENVIRONMENT.providerId,
    initialAddresses: INITIAL_ADDRESSES,
    showMessageBox: hint1980ShowSharesMessageBox
  })))));
}
//# sourceMappingURL=ReferralsSent.js.map